import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { Movie } from 'src/app/interfaces/cartelera-response';
import { PeliculasService } from 'src/app/services/peliculas.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {

  public movies: Movie[] = [];
  public moviesSlideshow: Movie[] = [];

  /*********infinity scroll ****/
  @HostListener('window:scroll', ['$event'])
  onScroll(): void{
    const treshold = 1200;
    const position = (document.documentElement.scrollTop || document.body.scrollTop) + treshold;

    const max = (document.documentElement.scrollHeight || document.body.scrollHeight);
    // console.log(position);
    // console.log(max);

    if ( position > max ){
      // console.log('llamar servicio');
      if( this.peliculasService.cargando){ return; }
      this.peliculasService.getCartelera()
      .subscribe( movies => {
          this.movies.push(...movies);
      });
    }
  }

  constructor( private peliculasService: PeliculasService ) {

   }

  ngOnInit( ): void {
    this.peliculasService.getCartelera()
    .subscribe( movies => {
      // console.log(resp.results);
      this.movies = movies;
      this.moviesSlideshow = movies.slice( 0, 5 );
    });
  }

  ngOnDestroy( ): void {
    this.peliculasService.resetCarteleraPage();
  }

}
